import React, { Component } from 'react';

export class PrintButton extends Component {

    constructor(props) {
        super(props);
        this.state = {};

        this.printQuote = this.printQuote.bind(this);
    }

    printQuote() {
        window.print();
    }

    render() {
        return (
            <div className="pull-right">
                <button type="button" className="btn btn-default hidden-print" onClick={this.printQuote}>
                <span className="glyphicon glyphicon-print" aria-hidden="true"></span>&nbsp;Print Quotation
            </button> 
            </div>
        );
    }
}